function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from '../../../../_snowpack/pkg/react.js';
import { colors } from '../../../css/index.js';

function Dots({
  size = 20,
  color = colors.label,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: ref,
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "5",
    r: "1.78571",
    fill: color
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "1.78571",
    fill: color
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "15",
    r: "1.78571",
    fill: color
  }));
}

export default /*#__PURE__*/forwardRef(Dots);